export const STATUS = {
    S: {name: "Success", style: {color: "green"}},
    F: {name: "Failed", style: {color: "red"}},
    P: {name: "Pending", style: {color: "orange"}},
    C: {name: "Cancelled", style: {color: "red"}},
}